<template>
  <v-container
    id="orders"
    tag="section"
  >
    <base-material-card
      color="indigo"
      icon="mdi-cash-register"
      inline
      class="px-5 py-3"
      top-actions
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Sales Report
        </div>
      </template>

      <template v-slot:top-actions>
        <debounce-v-btn
          class="px-2 ml-1"
          color="success"
          @click="csvExport(orders)"
        >
          Export
        </debounce-v-btn>
      </template>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        label="Search"
        hide-details
        single-line
        style="max-width: 250px;"
      />

      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="orders"
        :search.sync="search"
        :sort-desc="[false, false]"
        multi-sort
        class="row-action"
      >
        <template v-slot:item="{ item }">
          <tr @click="gotoDetails(item)">
            <td>
              <v-btn
                class="px-2 ml-1"
                color="info"
                rounded
                small
                @click="gotoDetails(item)"
              >
                Details
              </v-btn>
            </td>
            <td>{{ getCustomerName(item.customerId) }}</td>
            <td>{{ item.createDate | moment('DD/MM/YYYY HH:mm:ss') }}</td>
          </tr>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data: () => ({
      headers: [
        {
          sortable: false,
          text: '',
          width: '1%',
        },
        {
          sortable: true,
          text: 'Customer',
          value: 'customerName',
        },
        {
          sortable: true,
          text: 'Order Date',
          value: 'createDate',
        },
      ],
      search: '',
    }),
    computed: {
      products () {
        return this.$store.state.products.list
      },
      orders () {
        return this.$store.state.orders.list
      },
      ...mapGetters(['getCustomerName']),
    },
    created: function () {
      if (this.$store.state.orders.list.length === 0) {
        this.refreshOrders()
      }
    },
    methods: {
      async refreshOrders () {
        this.$store.dispatch('RefreshOrders')
      },
      gotoDetails (item) {
        this.$router.push({ name: 'Order', params: { uid: item.uid } })
      },
      csvExport (arrData) {
        let csvContent = 'data:text/csv;charset=utf-8,'
        csvContent += [
          this.getKeys(arrData[0]),
          ...arrData.map(item => {
            var csvValues = []
            var objectValues = Object.values(item)
            for (var i = 0; i < objectValues.length; i++) {
              if (Array.isArray(objectValues[i])) {
                for (var k = 0; k < objectValues[i].length; k++) {
                  csvValues.push(Object.values(objectValues[i][k]))
                }
              } else {
                csvValues.push(objectValues[i])
              }
            }
            return csvValues.join(',')
          }),
        ]
          .join('\n')
          .replace(/(^\[)|(\]$)/gm, '')

        const data = encodeURI(csvContent)
        const link = document.createElement('a')
        link.setAttribute('href', data)
        link.setAttribute('download', new Date().toJSON().split('T')[0].split('-').join('') + '_SalesReport.csv')
        link.click()
      },
      getKeys (item) {
        var keys = []
        var itemKeys = Object.keys(item)
        for (var i = 0; i < itemKeys.length; i++) {
          var nestedObject = item[itemKeys[i]]
          if (Array.isArray(nestedObject)) {
            for (var k = 0; k < nestedObject.length; k++) {
              var nestedItemKeys = Object.keys(nestedObject[k])
              for (var m = 0; m < nestedItemKeys.length; m++) {
                keys.push('order-line_' + nestedItemKeys[m])
              }
            }
          } else {
            keys.push('order_' + itemKeys[i])
          }
        }
        return keys
      },
    },
  }
</script>
